import React from 'react'
import ScrollComponents from '../../../../widgets/scrollComponents'
import './style.scss'

const popInInAnimation = {
  loop: false,
  from: { opacity: 0, x: -100 },
  to: { opacity: 1, x: 0 },
  config: {
    duration: 500,
  },
}

function TaglineFrame() {
  return (
    <div className={'intro-content-container intro-frame-3-container'}>
      <div className={'intro-frame-3-text-placeholder'}>
        <ScrollComponents springConfig={popInInAnimation}> 
          <p>I built app with ❤️</p>
          <p>and work with <b>passion</b></p>
        </ScrollComponents>
      </div>
    </div>
  )
}

export default TaglineFrame